export default {
  //代码里的key(唯一标识): '泰语',
  lang: 'th',
  appIntroduction: 'ภาพยนตร์และละครยอดนิยม ดูฟรีทุกเวลา',
  noMoreTip: 'จบแล้ว ไม่มีเนื้อหาอีกแล้ว~',
  navigator: {
    home: 'หน้าแรก',
    all: 'เนื้อหาทั้งหมด',
    news: 'ข่าว',
    download: 'ดาวน์โหลดแอป',
    contact: 'เกี่ยวกับเรา',
    joinUs: 'เข้าร่วมกับเรา'
  },
  seo: {
    title: 'loklok-ดูวิดีโอ HD ทุกโลก ออนไลน์ฟรี',
    keywords: 'Loklok, Loklok app, loklok tv, Loklok official website, Loklok web,Loklok movie,รัมชมออนไลน์,ดูฟรี,รับชมละครฟรี,หนัง,ซีรีส์,ซีรีส์เกาหลี, อะนิเมะ,ซีรีส์หวาน,ซีรีส์อเมริกา,สตรีมมิ่ง,snowdrop,our beloved summer,happiness,ranking of kings,demon slayer kimetsu no yaiba,attack on titan,true beauty,vincenzo,kimetsu no yaiba,ผ่า พิภพ ไท ทัน',
    description: 'ซีรีส์ฮอตสุด,หนังอเมริกาฮอตสุด,ลึกลับ,ตลก,ซีรีส์เกาหลีโรแมนติก,ระทึกขวัญ,วาไรตี้โชว์,ซับทุกประเภทยู่ใน Loklok',
    ogImage: 'https://static.loklok.video/img/tw-th.png',
    index: {
      title: 'Loklok - ดูหนัง HD ออนไลน์ฟรี - แนะนำหนังเรทสูงสุด',
      keywords: 'Loklok, แอพ Loklok, ดาวน์โหลด loklok, ดาวน์โหลด loklok, loklok pc, loklok apk, loklok ios, รัมชมออนไลน์,ดูฟรี,รับชมละครฟรี,loklok android, loklok สำหรับ ios, loklok สำหรับ Android, loklok android tv, loklok chromecast, kdrama เกาหลี, บ็อกซ์ออฟฟิศ, บ็อกซ์ออฟฟิศ ภาพยนตร์อเมริกัน, ภาพยนตร์ตะวันตก, ภาพยนตร์บล็อกบัสเตอร์, ภาพยนตร์ไทย, ภาพยนตร์ไทย, ละครโทรทัศน์, ละครโทรทัศน์, อนิเมะ, แอนิเมชั่น, การ์ตูน, รายการวาไรตี้, yaoi, ยูริ, bl, gl, ฮอลลีวู้ด, บอลลีวูด, ซอมบี้, หนึ่งชิ้น, นารูโตะ, ความรัก เรื่องเราตายกันหมด',
      description: 'Loklok เป็นแพลตฟอร์มสตรีมมิ่งวิดีโอแบบครบวงจรสำหรับคุณในการรับชมรายการทีวี ภาพยนตร์ แอนิเมชั่นจากทั่วทุกมุมโลก! ด้วยภาพยนตร์สุดพิเศษที่หลากหลาย คุณสามารถเลือกคำบรรยายหลายภาษาและคุณภาพของภาพระดับ Ultra-HD 4k ภาพยนตร์ใหม่ยอดนิยมจะออกทุกวัน!'
    },
    allPage: {
      title: 'Loklok ดูหนัง HD ออนไลน์ฟรี อะไรก็ได้ที่คุณจินตนาการได้',
      keywords: 'Loklok, แอพ Loklok, ดาวน์โหลด loklok, loklok pc, loklok apk,รัมชมออนไลน์,ดูฟรี,รับชมละครฟรี, แอนิเมชั่น, อะนิเมะ, ภาพยนตร์บล็อคบัสเตอร์, ตอนใหม่, ภาพยนตร์ที่จะมาถึง, การเปิดตัวใหม่ 2022, รอบปฐมทัศน์, ไซไฟ, โรแมนติกหวาน, ตลก, แอ็คชั่น, ความรัก, ภาพยนตร์ฟรี, ฟรี หนังออนไลน์ แอพหนังฟรี พวกเราทุกคนตายกันหมด F4 Thailand: Boys Over Flowers, Euphoria Season 2, Twenty five 21 one, การพยากรณ์ความรักและสภาพอากาศ， Ghost Doctor, True Beauty， Encanto, From， Business Proposal， Snowdrop， Rookie ตำรวจ，ยัง2คน',
      description: 'Loklok มีภาพยนตร์และเนื้อหาทางโทรทัศน์ยอดนิยมจำนวนมาก และรายการทีวีและภาพยนตร์ล่าสุดและดังสุด ๆ ให้รับชมฟรี! เนื้อหาความละเอียดสูงที่หลากหลาย ประสบการณ์ผู้ใช้ส่วนบุคคล และภาพยนตร์ยอดนิยมอยู่ที่นี่แล้ว'
    },
    articles: {
      title: 'Loklok ดูหนัง HD ออนไลน์ฟรี loklok ข่าวล่าสุด',
      keywords: 'Loklok, Loklok app, loklok download, loklok pc, loklok apk, รัมชมออนไลน์,ดูฟรี,รับชมละครฟรี,ข้อมูลภาพยนตร์และโทรทัศน์ล่าสุด, แนะนำภาพยนตร์, บทวิจารณ์ภาพยนตร์ยอดนิยม, ภาพยนตร์และโทรทัศน์ 2022, ภาพยนตร์รอบปฐมทัศน์, 2022 น่าดู, 2022 ต้องดู, 2022 ภาพยนตร์ภาพยนตร์, ภาพยนตร์ที่จะมาถึง 2023 , Peaky Blinders ซีซั่น 6, จู่โจมไททันซีซั่นสุดท้าย, ฤดูร้อนอันเป็นที่รักของเรา, โรงแรมทรานซิลเวเนีย 4: ทรานส์ฟอร์มเนีย, ความสุข',
      description: 'Loklok เป็นภาพยนตร์ยอดนิยมและเนื้อหาละครโทรทัศน์สามารถพบได้ทันที ภาพยนตร์บ็อกซ์ออฟฟิศและละครโทรทัศน์ทุกประเภทได้รับการอัปเดตใน 24 ชั่วโมง และภาพยนตร์และซีรีส์ยอดนิยมจะแสดงแบบเรียลไทม์ มาที่ Loklok และไล่ตามภาพยนตร์ของคุณ'
    },
    download: {
      title: 'Lokok ให้ดาวน์โหลดเวอร์ชันล่าสุดอย่างเป็นทางการ',
      keywords: 'Loklok, แอพ Loklok, ดาวน์โหลด loklok, loklok pc, loklok apk, loklok ดาวน์โหลด,รัมชมออนไลน์,ดูฟรี,รับชมละครฟรี, ดาวน์โหลด loklok, loklok ดาวน์โหลด apk, loklok ios ดาวน์โหลด, loklok ดาวน์โหลด android, loklok googleplay, loklok pc ดาวน์โหลด, loklok เวอร์ชันล่าสุด Loklok, Loklok desktop, Loklok pad',
      description: 'ดาวน์โหลดแอป Loklok เพื่อดูภาพยนตร์และซีรีส์ล่าสุดทางออนไลน์ที่บ้านหรือขณะเดินทางด้วยความละเอียดสูงสุดฟรี ดาวน์โหลดแอป Loklok เวอร์ชันล่าสุด หลังจากดาวน์โหลดและติดตั้งแล้ว ให้สแกนรหัส QR ของเว็บไซต์ผ่านโทรศัพท์มือถือ และเริ่มดูออนไลน์พร้อมกันบนพีซีของคุณ'
    },
    search: {

    },
    contact: {

    }
  },
  globalTip: {
    emptyTip: 'ไม่พบรายการปัจจุบัน',
    searchOther: 'ลองค้นหานังหรือซีรีส์อื่น'
  },
  loginModule: {
    title: 'เข้าสู่ระบบ',
    loginMethod: 'ใช้แอป loklok เพื่อสแกนรหัส QR',
    loginMethodTip: '(ต้องอัปเกรดเวอร์ชันเป็น 1.7.0 ขึ้นไป)',
    howToDownload: 'วิธีการดาวน์โหลด loklok',
    clickMe: 'คลิก',
    loginSuccess: 'เข้าสู่ระบบสำเร็จ',
    loginFailed: 'เข้าสู่ระบบล้มเหลว',
    codeExpired: 'รหัส QR หมดเวลาแล้ว',
    refreshButton: 'รีเฟรช',
    loginButton: 'เข้าสู่ระบบ',
    loginTip: 'หลังจากเข้าสู่ระบบ ดูเนื้อหาเว็บไซต์ทั้งหมดได้ฟรี',
    logoutButton: 'ออกจากระบบ',
    logoutTip: 'เพลิดเพลินกับการชมภาพยนตร์เถอะ!',
    areYouSure: 'ตกลงจะออกจากระบบหรือไม่?',
    sure: 'ตกลง',
    cancel: 'ยกเลิก'
  },
  toTop: {
    downloadApp: 'ดาวน์โหลดแอป',
    backToTop: 'กลับไปด้านบน'
  },
  indexPage: {
    title: 'LolokTV',
    more: 'เพิ่มเติม',
    seeMore: 'ดูเพิ่มเติม'
  },
  searchPage: {
    resultTitle: 'พบเนื้อหาต่อไป',
    rank: 'การค้นหาสุดฮอต Loklok',
    play: 'เล่น',
    popularSearch: 'การค้นหายอดนิยม',
    top1: 'อันดับที่ 1',
    top2: 'อันดับที่ 2',
    top3: 'อันดับที่ 3',
    top4: 'อันดับที่ 4',
    top5: 'อันดับที่ 5',
    top6: 'อันดับที่ 6',
    top7: 'อันดับที่ 7',
    top8: 'อันดับที่ 8',
    top9: 'อันดับที่ 9',
    top10: 'อันดับที่ 10',
    emptyTip: 'ขออภัย เราไม่มีเนื้อหานี้',
    emptyDesc: 'ลองค้นหาภาพยนตร์หรือรายการทีวีอื่น'
  },
  filterPage: {
    emptyTip: 'ขออภัย เราไม่มีเนื้อหานี้',
    emptyDesc: 'ลองค้นหาภาพยนตร์หรือรายการทีวีอื่น'
  },
  newsPage: {
    listTitle: 'ข่าวสารล่าสุด'
  },
  downloadPage: {
    scanQR: 'สแกนรหัส QR ดาวน์โหลดแอป',
    title1: 'หนังและซีรีส์ฮอตสุด',
    tip1: 'ดูฟรีทุกเวลา',
    title2: 'ซับทุกประเภท',
    tip2: 'ดูซีรีส์ชื่นมื่น',
    title3: 'ซิงค์พีซี/โทรศัพท์แบบเรียลไทม์'
  },
  detailPage: {
    autoTranslation: 'แปลโดยอัตโนมัติ',
    fiveMiniteTip: 'เพียง 5 นาที ดูหนังเต็มเรื่องเลย',
    loginTip2InDetailPage: 'ใช้แอป loklok สแกนรหัส QR ด้านล่างและดูเนื้อหาที่เหลือหลังจากเข้าสู่ระบบ',
    category: 'หมวดหมู่',
    moreDesc: 'เพิ่มเติม',
    youMayLike: 'คุณอาจจะชอบ',
    relatedSeries: 'รายการเกี่ยวข้อง',
    norelatedSeries: 'ไม่มีรายการที่เกี่ยวข้อง',
    emptyDesc: 'ขออภัย เราไม่มีเนื้อหานั้น',
    emptyTip: 'ขออภัย เราไม่มีเนื้อหานี้',
    vip: {
      dialog: {
        t1: 'เปิด VIP',
        t2: 'หากคุณต้องการรับชมเนื้อหาทั้งหมด โปรดไปที่แอพเพื่อเปิด VIP',
        t3: 'สามารถดาวน์โหลด App ได้ตามช่องทางต่อไปนี้',
        t4: 'มี VIP อยู่แล้ว กรุณา <span class="active">คลิกที่นี่</span>เพื่อเข้าสู่ระบบ',
        t5: 'มี VIP ยู่แล้ว โปรด<span class="active">รีเฟรช</span>เพื่อรับชมต่อ',
        t6: 'คุณได้รับชม {num} นาทีแล้ว หากคุณต้องการรับชมวิดีโอต่อ โปรดไปที่แอพ หรือหลังจากได้เปิด VIP ในแอพ คุณสามารถรับชมวิดีโอต่อไปได้'
      },
      player: {
        tip1: 'สามารถรับชมได้เพียง {num} นาที หากต้องการชมภาพยนตร์เต็ม โปรด<span class="active">ไปที่แอพ</span> หรือ<span class="active">เปิด VIP</span> ในแอพ'
      },
      episodes: {
        tip1: 'มาเป็น VIP และสนุกสนานกับเนื้อหาทั้งหมดเลย'
      }
    }
  },
  playerModule: {
    NETWORK_LOADING: 'เบราว์เซอร์กำลังดาวน์โหลดข้อมูล',
    NETWORK_NO_SOURCE: 'ไม่พบแหล่งที่มาของเสียง/วิดีโอ',
    MEDIA_ERR_ABORTED: 'กระบวนการดึงกลับถูกผู้ใช้ยกเลิก',
    MEDIA_ERR_NETWORK: 'เกิดข้อผิดพลาดในเวลาดาวน์โหลด',
    MEDIA_ERR_DECODE: 'การแยกวิเคราะห์การเล่นล้มเหลว ไม่สามารถเล่นไฟล์',
    MEDIA_ERR_SRC_NOT_SUPPORTED: 'รูปแบบเสียง/วิดีโอที่ไม่รองรับ',
    REPLAY: 'รีเพลย์',
    ERROR: 'ดูเหมือนว่าการเชื่อมต่อเครือข่ายมีปัญหา',
    PLAY_TIPS: 'เล่น',
    PAUSE_TIPS: 'ระงับ',
    PLAYNEXT_TIPS: 'ตอนทัดไป',
    DOWNLOAD_TIPS: 'ดาวน์โหลด',
    ROTATE_TIPS: 'หมุน',
    RELOAD_TIPS: 'โหลดใหม่',
    FULLSCREEN_TIPS: 'เข้าสู่เต็มหน้าจอ',
    EXITFULLSCREEN_TIPS: 'ออกจากเต็มหน้าจอ',
    CSSFULLSCREEN_TIPS: 'เข้ารูปแบบเต็มหน้าจอ',
    EXITCSSFULLSCREEN_TIPS: 'ออกจากรูปแบบเต็มหน้าจอ',
    TEXTTRACK: 'ซับไทเทิล',
    PIP: 'รูปภาพในภาพ',
    MINIPLAYER: 'เครื่องเล่นมินิ',
    SCREENSHOT: 'จับภาพหน้าจอ',
    LIVE: 'กำลังเล่น',
    OFF: 'ปิด',
    MINIPLAYER_DRAG: 'คลิกค้างไว้เพื่อลากวิดีโอ',
    AIRPLAY_TIPS: 'AirPlay',
    onlyPlayTip: 'เล่นเพียง {msg} นาที เข้าสู่ระบบเพื่อชมภาพยนตร์ครบ',
    loginTextButton: 'เข้าสู่ระบบ',
    replayButton: 'เล่นซ้ำ',
    nextButton: 'ตอนทัดไป',
    refreshButton: 'รีเฟรช',
    episode: 'ตอน'
  },
  contact: {
    business: 'ติดต่อทางธุรกิจ',
    question: 'การฟีดแบ็ค'
  },
  download_nd: {
    desc: 'มีหนังและซีรีส์จำนวนมาก รับชมฟรี',
    scanQR: 'สแกนคิวอาร์โค้ดเพื่อดาวน์โหลดแอป หรือ'
  },
  win: {
    feedback: {
      que: 'คำชี้แจงคำถามที่พบบ่อย',
      que1: 'คำถามที่พบบ่อย',
      content: 'เนื้อหาข้อเสนอแนะ',
      contact: 'ข้อมูลติดต่อ',
      submit: 'ส่งข้อเสนอแนะ',
      tip1: ' กรุณาให้รายละเอียดอย่างละเอียด และคุณสามารถแนบภาพหน้าจอที่เกี่ยวข้องได้ด้วย',
      tip2: 'กรุณาใส่อีเมลของคุณ',
      tip5: 'ขนาดของภาพที่อัปโหลดต้องน้อยกว่า {num}k',
      tip6: 'อัปโหลดได้สูงสุด 4 รูปภาพ',
      tip3: 'ส่งเรียบร้อยแล้ว กรุณารอสักครู่',
      tip4: 'เนื้อหาข้อเสนอแนะต้องมีไม่น้อยกว่า 10 คำ',
      error: 'ข้อผิดพลาดของระบบ'
    }
  },
  tv: {
    vip: {
      title: 'กรุณาเลือกสินค้าของคุณ',
      tip1: 'คุณสามารถดู QR โค้ดการชำระเงินได้หลังจากที่เข้าสู่ระบบ',
      refresh: 'รีเฟรช',
      tip2: 'สแกนรหัส QR เพื่อการชำระเงิน',
      recharge: 'ข้อตกลงการเติมเงิน',
      renewal: 'ข้อตกลงการต่ออายุ',
      login: 'เข้าสู่ระบบตอนนี้',
      tip3: 'ดูหลังจากเข้าสู่ระบบ',
      noOpen: 'VIP มาตรฐานยังไม่เปิดใช้',
      gift: 'ของขวัญ',
      succ: 'รีเฟรชสำเร็จ',
      fail: 'รีเฟรชล้มเหลว',
      day: 'VIP มาตรฐาน 1 วัน',
      days: 'VIP มาตรฐาน {x} วัน',
      expiration: 'เวลาหมดอายุ VIP มาตรฐาน: {x}',
      expired: 'VIP ของคุณหมดอายุแล้ว กรุณารีนิวให้เร็วที่สุด',
      interests1: ' เพลิดเพลินกับคุณภาพ HD 1080P',
      interests2: 'ปลดล็อกเนื้อหาทั้งหมด',
      interests3: 'เข้าสู่ระบบหลายอุปกรณ์'
    }
  }
}